import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Small = makeShortcode("Small");
const DateUpdated = makeShortcode("DateUpdated");
const DateDistance = makeShortcode("DateDistance");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "hi-im-scott",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#hi-im-scott",
        "aria-label": "hi im scott permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hi I'm Scott`}</h2>
    <Small mdxType="Small">
  Last updated: <DateUpdated date={`2020-04-16`} small={`true`} mdxType="DateUpdated" />
    </Small>
    <p>{`I'm a web developer for Creative Products here at `}<a parentName="p" {...{
        "href": "https://karmarama.com"
      }}>{`Karmarama`}</a>{`, based
in Farringdon, London UK.`}</p>
    <p>{`I'm married to a beautiful wife and we have a beautiful daughter and
three cats!`}</p>
    <h3 {...{
      "id": "---",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#---",
        "aria-label": "    permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`👨‍👩‍👧 🐱 😸 😹`}</h3>
    <p>{`A little bit more about me, since 2007 I had been working as a VBA
developer for companies such as Barclays, Deloitte and Fidelity.`}</p>
    <p>{`For the past, `}<DateDistance date={`2016-12-26`} mdxType="DateDistance" />{` now I have been
learning web development (JavaScript) and all related technologies.`}</p>
    <h3 {...{
      "id": "coding-history",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#coding-history",
        "aria-label": "coding history permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Coding history`}</h3>
    <p><strong parentName="p">{`Back Then:`}</strong>{` I learned to code `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Visual_Basic_for_Applications"
      }}>{`VBA`}</a>{` whilst working at Barclays Bank
as an assistant to a finance manager of a business area, the scripting
was to automate credit card reconciliation from SAP and generating
monthly reporting figures.`}</p>
    <p>{`I was lucky enough to have been spotted by one of the development
managers on a different team and offered a job as an Analyst Developer
in 2007, for the following 11 years I mainly worked with VBA in Excel,
Access, Word and in some cases PowerPoint.`}</p>
    <p>{`The majority of solutions I made were workflow tools, the tracking of
payments through a process, lots of greenfeild work with the focus on
using the tools the business had to hand, so, no SQL servers, just the
MS Office suite.`}</p>
    <p><strong parentName="p">{`And Now:`}</strong>{` I have (as of `}<DateUpdated date={`2020-04-16`} mdxType="DateUpdated" />{`) a 1,207
day GitHub streak, there are several OSS projects I like to contribute
to the majority of my commits are for my projects, feel free to take a
look 👀`}</p>
    <p>{`I'm a massive fan of the `}<a parentName="p" {...{
        "href": "https://jamstack.org/"
      }}>{`JAM Stack`}</a>{` and in particular the progressive
web app generator `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby`}</a>{`. Right now I'm enjoying integrating that
with as many things as possible, here are some examples:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://scottspence.me"
        }}>{`This site`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://thelocalhost.blog"
        }}>{`My blog`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mecv.xyz"
        }}>{`My CV`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://cheatsheets.xyz"
        }}>{`Cheat Sheets`}</a></li>
    </ul>
    <p>{`More details in the `}<a parentName="p" {...{
        "href": "#portfolio"
      }}>{`portfolio section`}</a>{`.`}</p>
    <p>{`Using Gatsby with CSS Grid and styled-components 💅 is an absolute joy
💜`}</p>
    <h3 {...{
      "id": "sectors-i-have-worked-in",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#sectors-i-have-worked-in",
        "aria-label": "sectors i have worked in permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Sectors I have worked in:`}</h3>
    <p>{`Finance (Risk, Asset Management), Property, Oil & Gas, Lloyd's
insurance market, government digital transformation and now creative
digital.`}</p>
    <p>{`Tools of my trade: HTML, CSS, JavaScript, React, Gatsby, Preact,
Next.js, GraphQL, styled-components 💅 GraphCMS and Zeit's `}<a parentName="p" {...{
        "href": "https://zeit.co/now"
      }}>{`now`}</a>{` and
`}<a parentName="p" {...{
        "href": "http://netlify.com/"
      }}>{`Netlify`}</a>{` for static site hosting.`}</p>
    <h3 {...{
      "id": "my-personality",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#my-personality",
        "aria-label": "my personality permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`My personality`}</h3>
    <p>{`I find it hard to identify my traits, so instead I took the
`}<a parentName="p" {...{
        "href": "https://www.16personalities.com/"
      }}>{`16Personalities`}</a>{` test, here are `}<a parentName="p" {...{
        "href": "https://www.16personalities.com/profiles/ba01a67248b68"
      }}>{`my results`}</a>{`.`}</p>
    <h2 {...{
      "id": "my-interests",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#my-interests",
        "aria-label": "my interests permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`My interests`}</h2>
    <p>{`I try to get to the gym three times a week to weight lift, that took
up quite a bit of my time over the last 3 years or so. I have focused
on the compound lifts bench, press, squat and my favourite,
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=b8sadCd7Lhc"
      }}>{`deadlift`}</a>{`!`}</p>
    <p>{`Before that I used to play tennis three times a week up to a county
standard, I'd love to have the time to play tennis again but between
all the above there's not much time left. 🙃`}</p>
    <p>{`If there's anything you want to ask, you can `}<a parentName="p" {...{
        "href": "https://github.com/spences10/ama"
      }}>{`Ask Me Anything`}</a></p>
    {
      /* Links */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      